import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useTranslate } from 'react-admin'
import { BLOGS_FIELDS } from '../../../providers/localization/constant'

export const BlogPublishNote: React.FC = () => {
  const translate = useTranslate()
  return (
    <Stack alignItems={{ xs: 'center', sm: 'flex-end' }} sx={{ pb: 1 }}>
      <Typography variant='caption' sx={{ color: 'error.main' }}>
        {translate(`${BLOGS_FIELDS}.note`)}
      </Typography>
    </Stack>
  )
}
